import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css';
import { postApi } from '../../services/api';

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.password) {
      setError('Please fill all fields');
      return;
    }

    setLoading(true);

    try {
      const response = await postApi("login", {
        email: formData.email,
        password: formData.password,
      });

      console.log(response.data);

      if (response.data?.status === true) {
        localStorage.setItem("token", response.data.token);
        navigate('/dashboard');
      } else {
        setError(response.data?.message || 'Login failed');
      }

    } catch (err) {
      console.error(err);

      // Improved error handling
      const errorMsg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Invalid email or password. Please try again.';

      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-bg">
        <div className="bg-animation"></div>
        <div className="floating-shapes">
          {[...Array(10)].map((_, i) => (
            <div
              key={i}
              className="shape"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 10}s`,
                animationDuration: `${20 + Math.random() * 10}s`
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="container">
        <div className="row min-vh-100 align-items-center justify-content-center">
          <div className="col-lg-5 col-md-7 col-11">
            <div className="auth-card glass-card">
              <div className="auth-header">
                <Link to="/" className="auth-logo">
                  <h2>ANTIPSUN</h2>
                  <span className="logo-tag">CRYPTO</span>
                </Link>
                <h3 className="auth-title">Welcome Back</h3>
                <p className="auth-subtitle">Login to your account to continue</p>
              </div>

              {/* Error Message */}
              {error && (
                <div className="alert alert-danger text-center py-2">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="auth-form">
                <div className="form-group mb-3">
                  <label className="form-label">
                    <i className="bi bi-envelope"></i> Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="form-group mb-3 position-relative">
                  <label className="form-label">
                    <i className="bi bi-lock"></i> Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    required
                  />
                  <span
                    className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer"
                    style={{ marginTop: '8px', cursor: 'pointer' }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                  </span>
                </div>

                <div className="form-group mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="remember"
                        name="remember"
                        checked={formData.remember}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="remember">
                        Remember me
                      </label>
                    </div>
                    <Link to="/forgot-password" className="auth-link">
                      Forgot Password?
                    </Link>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-gradient w-100 mb-3"
                  disabled={loading}
                >
                  {loading ? 'Logging in...' : (
                    <>
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      Login
                    </>
                  )}
                </button>

                <div className="divider">
                  <span>OR</span>
                </div>

                <div className="social-login">
                  <button type="button" className="btn btn-social">
                    <i className="bi bi-google"></i>
                  </button>
                  <button type="button" className="btn btn-social">
                    <i className="bi bi-facebook"></i>
                  </button>
                  <button type="button" className="btn btn-social">
                    <i className="bi bi-twitter"></i>
                  </button>
                </div>

                <div className="auth-footer">
                  <p>Don't have an account? <Link to="/register" className="auth-link">Sign Up</Link></p>
                </div>
              </form>
            </div>

            <div className="auth-info">
              <div className="info-item">
                <i className="bi bi-shield-check"></i>
                <span>Secure Login</span>
              </div>
              <div className="info-item">
                <i className="bi bi-lock"></i>
                <span>256-bit Encryption</span>
              </div>
              <div className="info-item">
                <i className="bi bi-patch-check"></i>
                <span>Verified Platform</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;